import { refs, domReady } from '../modules/utils.js';

class MenuList extends HTMLElement {
  #autoplayInterval = null;
  #userInteracted = false;
  #autoplayTimeout = 4000;

  static get observedAttributes() {
    return ['data-index'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'data-index') {
      this.#toggleItem();
    }
  }

  async connectedCallback() {
    await domReady();
    this.refs = refs(this);
    this.#setListeners();
    this.dataset.index = 0;
    this.#startAutoplay();
  }

  #setListeners() {
    this.refs.items?.forEach((el) => {
      el.addEventListener('mouseenter', () => {
        this.#userInteracted = true;
        this.#stopAutoplay();
        this.dataset.index = el.dataset.index;
      });
      el.addEventListener('mouseleave', () => {
        this.#userInteracted = false;
        setTimeout(() => {
          if (!this.#userInteracted) {
            this.#startAutoplay();
          }
        }, 200);
      });
    });
  }

  #startAutoplay() {
    if (this.#autoplayInterval) return;
    this.#autoplayInterval = setInterval(() => {
      if (!this.#userInteracted) {
        this.#nextItem();
      }
    }, this.#autoplayTimeout);
  }

  #stopAutoplay() {
    if (this.#autoplayInterval) {
      clearInterval(this.#autoplayInterval);
      this.#autoplayInterval = null;
    }
  }

  #nextItem() {
    const currentIndex = parseInt(this.dataset.index);
    const totalItems = this.refs.items?.length || 0;
    const nextIndex = (currentIndex + 1) % totalItems;
    this.dataset.index = nextIndex.toString();
  }

  #toggleItem() {
    this.refs.items?.forEach((el) => {
      const index = el.dataset.index;
      if (index === this.dataset.index) {
        el.setAttribute('data-active', '');
      }
      else {
        el.removeAttribute('data-active');
      }
    });
    this.refs.images?.forEach((el) => {
      const index = el.dataset.index;
      if (index === this.dataset.index) {
        el.setAttribute('data-active', '');
      }
      else {
        el.removeAttribute('data-active');
      }
    });
  }
}

customElements.define('menu-list', MenuList);
